import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

const AboutInfo = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { t } = useTranslation();

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div
            className={`about-info ${isExpanded ? 'expanded' : ''}`}
            onClick={toggleExpanded}
        >
            <div className="about-content">
                <div className="about-text">
                    {isExpanded ? t('marketing.about.close') : t('marketing.about.label')}
                </div>

                <div className="about-panel">
                    <h3 className="about-title">{t('marketing.about.title')}</h3>
                    <div className="about-description">
                        <p>{t('marketing.about.sections.intro')}</p>

                        <h4 className="about-subtitle">{t('marketing.about.sections.connectTitle')}</h4>
                        <p>{t('marketing.about.sections.connectBody')}</p>

                        <h4 className="about-subtitle">{t('marketing.about.sections.toolsTitle')}</h4>
                        <p>{t('marketing.about.sections.toolsBody')}</p>
                        <ul className="about-list">
                            <li>{t('marketing.about.list.coordination')}</li>
                            <li>{t('marketing.about.list.sharing')}</li>
                            <li>{t('marketing.about.list.collaboration')}</li>
                        </ul>

                        <h4 className="about-subtitle">{t('marketing.about.sections.empowerTitle')}</h4>
                        <p>{t('marketing.about.sections.empowerBody')}</p>

                        <p className="about-cta">{t('marketing.about.cta')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutInfo;
